module.exports = __webpack_public_path__ + "static/media/Group 94316.3210a4c9.svg";